<template>
	<section class="brandListing container">
		<div class="brandListing__Wrapper">
			<div class="brandListing__Item" v-for="(item, index) in data">
				<FlarePicture
					:src="{
						1440: { src: item.image, width: 421, height: 348, size: 'both', crop: 'fill' },
						768: { src: item.image, width: 335, height: 270, size: 'both', crop: 'fill' },
					}"
					class="brandListing__ItemImage"
					:alt="item.image?.alt"
					:lazy="index <= 2 ? false : true"
					:fetchPriority="index <= 2 ? 'high' : ''" />
				<div class="brandListing__ItemLogoWrapper">
					<Flare :srcset="item.color_logo" width="440" class="brandListing__ItemLogo" />
				</div>
				<h2 v-text="item.description" class="brandTextColor" :class="[useCamelCase(item.theme_class)]" />
				<p v-text="item.short_description" />
				<NuxtLink :to="item.sef" class="button__Text--Underline">{{ $t('readMore') }}</NuxtLink>
			</div>
		</div>
	</section>
</template>

<script setup>
	defineProps({
		data: {},
	});
</script>

<style lang="scss">
	@import url('@/assets/styles/components/_brandListing.scss');
</style>
